import {
  CHALLAN,
  DAMAGE,
  GATE_PASS,
  GATE_PASS_ADD,
  GATE_PASS_EDIT,
  DAMAGE_ADD,
  DAMAGE_EDIT,
  INTERNAL_REQUISITION,
  INTERNAL_REQUISITION_ADD,
  INTERNAL_REQUISITION_EDIT,
  INTERNAL_REQUISITION_VIEW,
  INVENTORY,
  MRR,
  MRR_VIEW,
  QUALITY_CERTIFICATE,
  QUALITY_CERTIFICATE_VIEW,
  SPR,
  SPR_VIEW,
  CHALLAN_VIEW,
  STOCK,
  STOCK_ADJUSTMENT,
  STOCK_ADJUSTMENT_ADD,
  STOCK_ADJUSTMENT_EDIT,
  REQUISITION_ISSUE,
  REQUISITION_ISSUE_VIEW,
  STOCK_TRANSFER,
  STOCK_TRANSFER_ADD,
  STOCK_TRANSFER_EDIT,
  STOCK_TRANSFER_VIEW,
} from '@constants/internal-route.constant'
import { ROUTE_CODES } from '@constants/route-codes.constant';
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'

export const InventoryRoutes: IAppRoutes = {
  link: INVENTORY,
  routeCode: ROUTE_CODES.INVENTORY,
  childrens: [
    {
      link: STOCK,
      routeCode: ROUTE_CODES.INV_STOCKS,
      element: lazy(() => import('@modules/inventory/Stock')),
    },
    {
      link: STOCK_ADJUSTMENT,
      routeCode: ROUTE_CODES.INV_STOCK_ADJUSTMENT,
      element: lazy(() => import('@modules/inventory/adjustment')),
    },
    {
      link: STOCK_ADJUSTMENT_ADD,
      routeCode: ROUTE_CODES.INV_STOCK_ADJUSTMENT,
      action: 'create',
      element: lazy(() => import('@modules/inventory/adjustment/Form')),
    },
    {
      link: STOCK_ADJUSTMENT_EDIT({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_STOCK_ADJUSTMENT,
      action: 'update',
      element: lazy(() => import('@modules/inventory/adjustment/Form')),
    },
    {
      link: REQUISITION_ISSUE,
      routeCode: ROUTE_CODES.INV_REQUISITION_ISSUE,
      element: lazy(() => import('@modules/inventory/requisition-issue')),
    },
    {
      link: REQUISITION_ISSUE_VIEW({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_REQUISITION_ISSUE,
      element: lazy(() => import('@modules/inventory/requisition-issue/View')),
    },
    // The procurement chain the STORE works: requisition -> SPR -> PO -> challan -> QC -> MRR.
    // Only the PO is a Procurement screen; these four moved here on 2026-09-23. The routeCodes are
    // unchanged (SPR_CRUD/CHALLAN_CRUD/QC_CRUD/MRR_CRUD), so nobody's access moved with them.
    {
      link: SPR,
      routeCode: ROUTE_CODES.PROCUREMENT_SPR,
      element: lazy(() => import('@modules/inventory/spr')),
    },
    // Read-only detail pages. Each carries the SAME routeCode as its list: PrivateRoutes reads a
    // MISSING code as "always allow", so leaving one off would make the document the one ungated
    // screen in the group -- and hiding a row is worthless if its id still opens it.
    {
      link: SPR_VIEW({id: ':id'}),
      routeCode: ROUTE_CODES.PROCUREMENT_SPR,
      element: lazy(() => import('@modules/inventory/spr/View')),
    },
    {
      link: CHALLAN,
      routeCode: ROUTE_CODES.PROCUREMENT_CHALLAN,
      element: lazy(() => import('@modules/inventory/challan')),
    },
    {
      link: CHALLAN_VIEW({id: ':id'}),
      routeCode: ROUTE_CODES.PROCUREMENT_CHALLAN,
      element: lazy(() => import('@modules/inventory/challan/View')),
    },
    {
      link: QUALITY_CERTIFICATE,
      routeCode: ROUTE_CODES.PROCUREMENT_QC,
      element: lazy(() => import('@modules/inventory/quality-certificate')),
    },
    {
      link: QUALITY_CERTIFICATE_VIEW({id: ':id'}),
      routeCode: ROUTE_CODES.PROCUREMENT_QC,
      element: lazy(() => import('@modules/inventory/quality-certificate/View')),
    },
    {
      link: MRR,
      routeCode: ROUTE_CODES.PROCUREMENT_MRR,
      element: lazy(() => import('@modules/inventory/mrr')),
    },
    {
      link: MRR_VIEW({id: ':id'}),
      routeCode: ROUTE_CODES.PROCUREMENT_MRR,
      element: lazy(() => import('@modules/inventory/mrr/View')),
    },
    {
      link: STOCK_TRANSFER,
      routeCode: ROUTE_CODES.INV_TRANSFER,
      element: lazy(() => import('@modules/inventory/stock-transfer')),
    },
    {
      link: STOCK_TRANSFER_ADD,
      routeCode: ROUTE_CODES.INV_TRANSFER,
      action: 'create',
      element: lazy(() => import('@modules/inventory/stock-transfer/Form')),
    },
    {
      link: STOCK_TRANSFER_EDIT({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_TRANSFER,
      action: 'update',
      element: lazy(() => import('@modules/inventory/stock-transfer/Form')),
    },
    {
      link: STOCK_TRANSFER_VIEW({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_TRANSFER,
      element: lazy(() => import('@modules/inventory/stock-transfer/View')),
    },
    {
      link: INTERNAL_REQUISITION,
      routeCode: ROUTE_CODES.INV_INTERNAL_REQUISITION,
      element: lazy(() => import('@modules/inventory/internal-requisition')),
    },
    {
      link: INTERNAL_REQUISITION_ADD,
      routeCode: ROUTE_CODES.INV_INTERNAL_REQUISITION,
      action: 'create',
      element: lazy(() => import('@modules/inventory/internal-requisition/Form')),
    },
    {
      link: INTERNAL_REQUISITION_EDIT({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_INTERNAL_REQUISITION,
      action: 'update',
      element: lazy(() => import('@modules/inventory/internal-requisition/Form')),
    },
    {
      link: INTERNAL_REQUISITION_VIEW({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_INTERNAL_REQUISITION,
      element: lazy(() => import('@modules/inventory/internal-requisition/View')),
    },
    {
      link: DAMAGE,
      routeCode: ROUTE_CODES.INV_DAMAGE,
      element: lazy(() => import('@modules/inventory/damage')),
    },
    {
      link: DAMAGE_ADD,
      routeCode: ROUTE_CODES.INV_DAMAGE,
      action: 'create',
      element: lazy(() => import('@modules/inventory/damage/Form')),
    },
    {
      link: DAMAGE_EDIT({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_DAMAGE,
      action: 'update',
      element: lazy(() => import('@modules/inventory/damage/Form')),
    },
    {
      link: GATE_PASS,
      routeCode: ROUTE_CODES.INV_GATE_PASS,
      element: lazy(() => import('@modules/inventory/gate-pass')),
    },
    {
      link: GATE_PASS_ADD,
      routeCode: ROUTE_CODES.INV_GATE_PASS,
      action: 'create',
      element: lazy(() => import('@modules/inventory/gate-pass/Form')),
    },
    {
      link: GATE_PASS_EDIT({ id: ':id' }),
      routeCode: ROUTE_CODES.INV_GATE_PASS,
      action: 'update',
      element: lazy(() => import('@modules/inventory/gate-pass/Form')),
    },
  ],
};
